import { css } from '@emotion/css'
import { spacing } from '../../styles'
import { beat } from '../../styles/animations'
import getThemeColors, { colors } from '../../themes'

const styles = {
  wrapper: css({
    display: 'inline-flex',

    '& > * + *': {
      marginLeft: spacing.extraSmall,
    },
  }),

  spinner: css({
    display: 'inline-flex',
    width: spacing.small,
    height: spacing.small,
    borderRadius: '50%',
    animation: `${beat} 0.75s infinite`,

    '&:nth-child(2)': {
      animationDelay: '0.25s',
    },

    '&:nth-child(3)': {
      animationDelay: '0.5s',
    },
  }),
}

export default styles

export const spinnerTheme = (theme, style) => {
  if (style === 'white') {
    return css({
      backgroundColor: colors.white,
    })
  }

  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.base,
  })
}
